function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1445",
  "data-name": "Rectangle 1445",
  width: 3,
  height: 3,
  transform: "translate(0 21.875)",
  fill: "#707070"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1446",
  "data-name": "Rectangle 1446",
  width: 3,
  height: 3,
  transform: "translate(0 16.875)",
  fill: "#707070"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1447",
  "data-name": "Rectangle 1447",
  width: 3,
  height: 3,
  transform: "translate(0 11.875)",
  fill: "#707070"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1448",
  "data-name": "Rectangle 1448",
  width: 3,
  height: 3,
  transform: "translate(0 6.875)",
  fill: "#707070"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1449",
  "data-name": "Rectangle 1449",
  width: 3,
  height: 3,
  transform: "translate(0 26.875)",
  fill: "#707070"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1450",
  "data-name": "Rectangle 1450",
  width: 3,
  height: 3,
  transform: "translate(0 31.875)",
  fill: "#707070"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1451",
  "data-name": "Rectangle 1451",
  width: 3,
  height: 3,
  transform: "translate(5 31.875)",
  fill: "#707070"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1452",
  "data-name": "Rectangle 1452",
  width: 3,
  height: 3,
  transform: "translate(10 31.875)",
  fill: "#707070"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1453",
  "data-name": "Rectangle 1453",
  width: 3,
  height: 3,
  transform: "translate(15 31.875)",
  fill: "#707070"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1454",
  "data-name": "Rectangle 1454",
  width: 3,
  height: 3,
  transform: "translate(20 31.875)",
  fill: "#707070"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1455",
  "data-name": "Rectangle 1455",
  width: 3,
  height: 3,
  transform: "translate(25 31.875)",
  fill: "#707070"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1429",
  "data-name": "Path 1429",
  d: "M365.911,626H344.321A3.325,3.325,0,0,0,341,629.322v21.589a3.326,3.326,0,0,0,3.321,3.322h21.589a3.326,3.326,0,0,0,3.321-3.322V629.322A3.325,3.325,0,0,0,365.911,626Zm-21.589,24.911V629.322h21.589l0,21.589Z",
  transform: "translate(-334.357 -626.001)",
  fill: "#707070"
});

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_602",
    "data-name": "Group 602",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.875,
    height: 34.875,
    viewBox: "0 0 34.875 34.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a956e5f7.svg";
export { ForwardRef as ReactComponent };